// Option lists for the public inquiry forms. The admin lead view reads the same
// lists so stored values (e.g. take_away) display with the wording the guest saw.
// lumen/app/Models/LeadForm.php OPTION_LABELS mirrors these for the PDF.

export const DATE_FLEXIBILITY_OPTIONS = [
    { value: 'set_in_stone', label: `It's set in stone!` },
    { value: 'maybe', label: 'Maybe...' }
]

export const NEEDS_VENUE_OPTIONS = [
    { value: 'no', label: 'No' },
    { value: 'yes', label: 'Yes' },
    { value: 'maybe', label: 'Maybe' }
]

export const NEEDS_BARTENDER_OPTIONS = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
    { value: 'maybe', label: 'Maybe' }
]

export const PREFERRED_CONTACT_OPTIONS = [
    { value: 'text', label: 'Text' },
    { value: 'call', label: 'Call' },
    { value: 'email', label: 'Email' },
    { value: 'no_preference', label: 'No Preference' }
]

export const YES_NO_OPTIONS = [
    { value: true, label: 'Yes' },
    { value: false, label: 'No' }
]

export const ALLERGY_COUNT_OPTIONS = [
    { value: '0', label: '0' },
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3+', label: '3+' }
]

// Each meal here needs a matching style question in The Format on the multi-day
// form — buildPayload() stores one style per scheduled meal — so only meals with
// a defined style option belong in this list.
export const MEAL_OPTIONS = [
    { value: 'breakfast', label: 'Breakfast' },
    { value: 'lunch', label: 'Lunch' },
    { value: 'dinner', label: 'Dinner' }
]

export const BREAKFAST_STYLE_OPTIONS = [
    { value: 'plated', label: 'Plated' },
    { value: 'chefs_counter_buffet', label: `Chef's Counter Buffet` },
    { value: 'grazing', label: 'Grazing' }
]

export const LUNCH_STYLE_OPTIONS = [
    { value: 'plated', label: 'Plated' },
    { value: 'chefs_counter_buffet', label: `Chef's Counter Buffet` },
    { value: 'grazing', label: 'Grazing' },
    { value: 'take_away', label: 'Take-Away / Grab-and-Go' }
]

export const DINNER_STYLE_OPTIONS = [
    { value: 'plated', label: 'Plated' },
    { value: 'chefs_counter_buffet', label: `Chef's Counter Buffet` },
    { value: 'grazing', label: 'Grazing' },
    { value: 'cocktail_party', label: 'Cocktail Party' },
    { value: 'canape_service', label: 'Canapé Service (Passed Only)' }
]

export const KITCHEN_MANAGEMENT_OPTIONS = [
    { value: 'manage_all', label: 'Manage the kitchen and cleanup throughout the day' },
    { value: 'prepare_only', label: 'Just prepare the meals' }
]

export const DAYS_OF_WEEK_OPTIONS = [
    { value: 'monday', label: 'Mon' },
    { value: 'tuesday', label: 'Tue' },
    { value: 'wednesday', label: 'Wed' },
    { value: 'thursday', label: 'Thu' },
    { value: 'friday', label: 'Fri' },
    { value: 'saturday', label: 'Sat' },
    { value: 'sunday', label: 'Sun' }
]

export const MEAL_TIME_OPTIONS = [
    { value: 'breakfast', label: 'Breakfast' },
    { value: 'lunch', label: 'Lunch' },
    { value: 'snack', label: 'Snack' },
    { value: 'dinner', label: 'Dinner' }
]

export const DELIVERY_TYPE_OPTIONS = [
    { value: 'in_home', label: 'In-Home Chef' },
    { value: 'drop_off', label: 'Drop-Off Meals' }
]

// one label map for every multi-day meal style, since the schedule stores them per meal
export const MEAL_STYLE_OPTIONS = [...BREAKFAST_STYLE_OPTIONS, ...LUNCH_STYLE_OPTIONS, ...DINNER_STYLE_OPTIONS]
    .filter((opt, idx, all) => all.findIndex(o => o.value === opt.value) === idx)

export const optionLabel = (options, value) => {
    if (value === null || value === undefined || value === '') {
        return null
    }
    const found = options.find(opt => opt.value === value)
    return found ? found.label : value
}
